<div
  class="accordion-header toggle"
  [ngClass]="{ 'is-active': isActive }"
  (click)="toggle()"
>
  <ng-content />
  <svg-icon src="/assets/icons/general/chevron-right.svg" />
</div>
